import React, {useState} from 'react';

import './Tab.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import classnames from 'classnames'

const Tab = (props) => {
  const { title, noCollapse, initCollapse, children } = props
  const [ isCollapse, setIsCollapse ] = useState(!!initCollapse)
  const handleOnClickCollapseBtn = (e) => {
    setIsCollapse(!isCollapse)
  }

  const tabBtnClassname = classnames('collapse-btn', {
    'coll': isCollapse,
  })

  const contentAreaClassname = classnames('content-area', {
    'on': !isCollapse,
  })

  return (
    <div className="global-tab">
      <div className="head">
        {title}
        {!noCollapse && 
          <button className={tabBtnClassname} onClick={handleOnClickCollapseBtn}>
            <FontAwesomeIcon icon={faChevronDown} />
          </button>
        }
      </div>
      <div className={contentAreaClassname}>
        {children}
        {/* { !isCollapse && children} */}
      </div>
    </div>
  )
}

export default Tab